export enum GraphicContentType {
  Image = 'image',
  Video = 'video',
}

export enum ArticleVideoType {
  HeadlineVideo = 'HeadlineVideo',
  ArticleVideo = 'ArticleVideo',
  YoutubeVideo = 'YoutubeVideo',
  EmbeddedJSVideo = 'EmbeddedJSVideo',
}
